import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconAmplitudesSizeS from './IconAmplitudes_size_s';

const props: CreateIconArguments = {
  l: IconAmplitudesSizeS,
  m: IconAmplitudesSizeS,
  s: IconAmplitudesSizeS,
  xs: IconAmplitudesSizeS,
  name: 'IconAmplitudes',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
